import { Product } from '@interfaces';
import { extractExtraInfo } from '@screens/product/utils/extractExtraInfo';
import { NEXT_PUBLIC_NO_PRICE_FALLBACK } from '@config/environment';
import { CurrencyFormatter } from '@utils/formatters/CurrencyFormatter';

import {
  RootDiv,
  TitleTypography,
  DetailsTextTypography,
  DetailsPriceDiv,
  DetailsPriceTypographyBold,
  DetailsPriceTypographyLight,
} from '../styles/ItemDetails.styles';

interface CartProductDetailsProps {
  product: Product;
  price: number;
  quantity: number;
}

const currFormat = new CurrencyFormatter({
  fallback: NEXT_PUBLIC_NO_PRICE_FALLBACK,
});

export function CartProductDetails(props: CartProductDetailsProps) {
  const { product, price, quantity } = props;
  return (
    <RootDiv>
      <TitleTypography variant="subtitle2">{product.name}</TitleTypography>
      <DetailsTextTypography>{extractExtraInfo(product)}</DetailsTextTypography>
      <DetailsTextTypography>{product.laboratory}</DetailsTextTypography>
      <DetailsPriceDiv>
        <DetailsPriceTypographyBold>
          {quantity > 1 && `${currFormat.format(price * quantity)}・`}
        </DetailsPriceTypographyBold>
        <DetailsPriceTypographyLight>
          {`${currFormat.format(price)}`}/un
        </DetailsPriceTypographyLight>
      </DetailsPriceDiv>
    </RootDiv>
  );
}
